import React, { useState } from 'react';
import styles from './toolApproval.module.scss';
import { ToolCall } from '@/modules/chat/types/chatResponse';
import { BaseButton } from '@/components/ui/BaseButton/BaseButton';

type Props = {
  approvals: ToolCall[];
  onReview: (reviews: { [toolCallId: string]: boolean }) => void;
};

const ToolApproval: React.FC<Props> = ({ approvals, onReview }) => {
  const [reviews, setReviews] = useState<{ [key: string]: boolean }>(() => {
    const initial: { [key: string]: boolean } = {};
    approvals.forEach((approval) => {
      initial[approval.tool_call_id] = true;
    });
    return initial;
  });

  const handleToggleReview = (toolCall_id: string) => {
    setReviews((prev) => ({ ...prev, [toolCall_id]: !prev[toolCall_id] }));
  };

  const handleSubmit = () => {
    onReview(reviews);
  };

  if (!approvals || approvals.length === 0) return null;

  return (
    <div className={styles['tool-approval-container']}>
      <div className={styles['approvals-list']}>
        {approvals.map((approval) => {
          const argsDisplay =
            typeof approval.args === 'string' ? approval.args : JSON.stringify(approval.args, null, 2);

          const isApproved = reviews[approval.tool_call_id];

          return (
            <div
              key={approval.tool_call_id}
              className={`${styles['tool-approval-item']} ${isApproved ? styles['approved'] : styles['denied']}`}
              onClick={() => handleToggleReview(approval.tool_call_id)}
            >
              <div className={styles['header']}>
                <div className={styles['checkbox-wrapper']}>
                  <div className={`${styles['custom-checkbox']} ${isApproved ? styles['checked'] : ''}`}>
                    {isApproved && (
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M10 3L4.5 8.5L2 6"
                          stroke="white"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    )}
                  </div>
                  <h4 className={styles['tool-name']}>{approval.tool_name}</h4>
                </div>
                <span className={styles['status-label']}>{isApproved ? 'Permitido' : 'Denegado'}</span>
              </div>
              <div className={styles['body']}>
                <pre className={styles['code-block']}>{argsDisplay}</pre>
              </div>
            </div>
          );
        })}
      </div>
      <div className={styles['submit-container']}>
        <BaseButton
          variant="primary"
          text={`Confirmar (${Object.values(reviews).filter(Boolean).length} acciones)`}
          onClick={handleSubmit}
        />
      </div>
    </div>
  );
};

export default ToolApproval;
